module.exports = __webpack_public_path__ + "static/media/video.26af6b3.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/video.mp4
// module id = nV+K
// module chunks = 41